import { render, staticRenderFns } from "./AfterButtonsComponent.vue?vue&type=template&id=8f588c7c"
import script from "./AfterButtonsComponent.vue?vue&type=script&lang=js"
export * from "./AfterButtonsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports